import { RoutingPath } from '../enums/routing-path.enum';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RoutingService {
  static readonly ROOT = '/';

  static readonly ONBOARDING = `/${ RoutingPath.ONBOARDING }`;
  static readonly LOGIN = `/${ RoutingPath.LOGIN }`;
  static readonly REGISTER = `/${ RoutingPath.REGISTER }`;
  static readonly REGISTER_SUCCESS = `/${ RoutingPath.REGISTER }/${ RoutingPath.SUCCESS }`;
  static readonly THEME = `/${ RoutingPath.THEME }`;

  static readonly FORGOT_PASSWORD = `/${ RoutingPath.FORGOT_PASSWORD }`;
  static FORGOT_PASSWORD_BACKEND_REDIRECT = `recover/reset/:${ RoutingPath.FORGOT_PASSWORD_TOKEN_PARAM }`;
  static readonly FORGOT_PASSWORD_VERIFICATION = `/${ RoutingPath.FORGOT_PASSWORD }/${ RoutingPath.FORGOT_PASSWORD_VERIFICATION }`;
  static readonly FORGOT_PASSWORD_NEW_PASSWORD = `/${ RoutingPath.FORGOT_PASSWORD }/${ RoutingPath.FORGOT_PASSWORD_NEW_PASSWORD }`;
  static readonly FORGOT_PASSWORD_SUCCESS = `/${ RoutingPath.FORGOT_PASSWORD }/${ RoutingPath.SUCCESS }`;

  static readonly HOME = `/${ RoutingPath.HOME }`;
  static readonly DEVELOPMENTS = `/${ RoutingPath.DEVELOPMENTS }`;
  static readonly FAVORITES = `/${ RoutingPath.FAVORITES }`;
  static readonly TARRAF_NEWS = `/${ RoutingPath.NEWS }`;
  static readonly NOTIFICATIONS = `/${ RoutingPath.NOTIFICATIONS }`;
  static readonly CONTACT = `/${ RoutingPath.CONTACT }`;
  static readonly CONTACT_SUCCESS = `/${ RoutingPath.CONTACT }/${ RoutingPath.SUCCESS }`;
  static readonly CONFIGS = `/${ RoutingPath.CONFIGS }`;
  static readonly CONFIGS_ACCOUNT = `/${ RoutingPath.CONFIGS }/${ RoutingPath.ACCOUNT }`;
}
